import {initItemcardImages} from "../../../default/global/js/itemcardImages";
import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";

window.addEventListener("load", (event) => {
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();

    document.querySelectorAll(".filegalleryFile").forEach(el => {
        el.addEventListener("click", (event) => {
            event.preventDefault();
            window.open(el.dataset.target, "_blank");
            return false;
        });
    });

});